const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/store/gepartnerSearch.ts';
import Imm from 'immutable';
import { IActionHandlersMap, KisApiAction, makeReducer, ReducerState } from '@cistec/common_web/defs/actionTypes';
import { addRequestActionHandlers, getData, removeStructure } from '@cistec/common_web/utils/redux4Requests';
import { convertListObjectToArray } from '@cistec/common_web/utils/kisim';
import {
    ACTION_TYPE_CLEAR_GEPARTNER_SEARCH_RESULT,
    REQUEST_ACTION_TYPES_SEARCH_GEPARTNER,
} from 'App/actions/gepartner';
import { PatAppStoreState } from './setup/rootReducer';
import { createSelector } from 'reselect';

const handleClearGepartnerSearchResults = (state: ReducerState, action: any) => {
    return removeStructure(state, [action.meta.componentId]);
};

const handlers: IActionHandlersMap = {
    [ACTION_TYPE_CLEAR_GEPARTNER_SEARCH_RESULT]: handleClearGepartnerSearchResults,
};

const getKeys = (action: KisApiAction) => [action.meta.componentId];

const getGEPartnerData = (action: KisApiAction) => ({
    list: action.payload.List ? convertListObjectToArray(action.payload.List) : [],
    hasMoreResult: action.payload.Info?.HasMoreResults || '0',
});

addRequestActionHandlers(handlers, REQUEST_ACTION_TYPES_SEARCH_GEPARTNER, getKeys, getGEPartnerData);

export const searchGepartnerReducer = makeReducer(handlers);

// SELECTORS

const selectReducerState = (state: PatAppStoreState) => state.searchGepartners;

export const makeSelectGepartnerSearchResults = (componentId: string) =>
    createSelector(
        [selectReducerState],
        (reducerState: ReducerState) =>
            getData(reducerState, [componentId]) ?? {
                list: undefined,
                hasMoreResult: '0',
            }
    );

export const selectGepartnerSearchResultsRFF = (state: PatAppStoreState) => {
    const data = makeSelectGepartnerSearchResults('rff')(state);
    return { list: Imm.fromJS(data.list || []), hasMoreResult: data.hasMoreResult };
};
